<template>
  <div class="pb-5">
    <b-navbar toggleable="lg" type="dark">
      <div class="container">
        <router-link to="/">
          <img src="/img/logo_bike.svg" height="40" />
        </router-link>
      </div>
    </b-navbar>

    <div class="container pt-5">
      <div class="row text-left">
        <div class="col-lg-6 mb-3 align-self-center2">
          <h2 class="font-weight-normal">Crie agora sua conta Bike Registrada!</h2>
          <div
            class="font-weight-bold my-3"
          >Sua conta é a porta de entrada para todos os serviços da nossa plataforma:</div>
          <p>
            <i class="fas fa-check text-success mr-2"></i>Classificados de compra e venda de bicicletas Bike Registrada.
          </p>
          <p>
            <i class="fas fa-check text-success mr-2"></i>Seguro para bicicletas Bike Registrada;
          </p>
          <p>
            <i class="fas fa-check text-success mr-2"></i>Selo de segurança Bike Registrada;
          </p>
        </div>
        <div class="col-lg-6">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onClickCriarConta)">
              <div class="form-group">
                <label>Tipo de conta:</label>
                <b-form-group>
                  <b-form-radio
                    v-model="novaConta.tipoConta"
                    name="some-radios"
                    :value="config.TIPO_CONTA_PESSOA_FISICA"
                    inline
                    @input="onChangeTipoConta"
                  >Pessoa física</b-form-radio>
                  <b-form-radio
                    v-model="novaConta.tipoConta"
                    name="some-radios"
                    :value="config.TIPO_CONTA_PESSOA_JURIDICA"
                    inline
                    @input="onChangeTipoConta"
                  >Pessoa jurídica</b-form-radio>
                </b-form-group>
              </div>
              <div
                class="form-group"
                v-if="novaConta.tipoConta == config.TIPO_CONTA_PESSOA_JURIDICA"
              >
                <label>Nome fantasia:</label>
                <ValidationProvider
                  name="Nome fantasia"
                  rules="required|min:3"
                  v-slot="{ errors, classes }"
                >
                  <input type="text" class="form-control" v-model="novaConta.nome" :class="classes" />
                  <span class="invalid-feedback">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="form-group" v-else>
                <label>Seu nome completo:</label>
                <ValidationProvider name="Nome" rules="required|min:3" v-slot="{ errors, classes }">
                  <input type="text" class="form-control" v-model="novaConta.nome" :class="classes" />
                  <span class="invalid-feedback">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div
                class="form-group"
                v-if="novaConta.tipoConta == config.TIPO_CONTA_PESSOA_JURIDICA"
              >
                <label>Razão Social:</label>
                <ValidationProvider
                  name="Razão social"
                  rules="required|min:3"
                  v-slot="{ errors, classes }"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="novaConta.razaoSocial"
                    :class="classes"
                  />
                  <span class="invalid-feedback">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div
                class="form-group"
                v-if="novaConta.tipoConta == config.TIPO_CONTA_PESSOA_JURIDICA"
              >
                <label>CNPJ:</label>
                <ValidationProvider name="CNPJ" rules="required|cnpj" v-slot="{ errors, classes }">
                  <input
                    type="text"
                    class="form-control"
                    v-model="novaConta.cnpj"
                    :class="classes"
                    v-mask="'##.###.###/####-##'"
                    placeholder="00.000.000/0000-00"
                  />
                  <span class="invalid-feedback">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Seu melhor e-mail:</label>
                    <ValidationProvider
                      name="e-mail"
                      rules="required|email"
                      v-slot="{ errors, classes }"
                    >
                      <input
                        type="email"
                        class="form-control"
                        :class="classes"
                        v-model="novaConta.email"
                        autocomplete="nope"
                      />
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <ValidationProvider
                      name="confirmar e-mail"
                      rules="required|confirmed:e-mail"
                      v-slot="{ errors, classes }"
                    >
                      <label>Confirme seu e-mail:</label>
                      <input
                        type="email"
                        class="form-control"
                        :class="classes"
                        v-model="novaConta.confirmarEmail"
                        autocomplete="nope"
                      />
                      <span
                        class="invalid-feedback"
                        v-if="errors.length > 0"
                      >A confirmação do e-mail deve ser igual</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Sua nova senha:</label>
                    <ValidationProvider
                      name="senha"
                      rules="required|min:6"
                      v-slot="{ errors, classes }"
                    >
                      <input
                        type="password"
                        class="form-control"
                        :class="classes"
                        v-model="novaConta.senha"
                        autocomplete="new-password"
                      />
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Confirme sua senha:</label>
                    <ValidationProvider
                      name="confirmar senha"
                      rules="required|confirmed:senha"
                      v-slot="{ errors, classes }"
                    >
                      <input
                        type="password"
                        class="form-control"
                        :class="classes"
                        v-model="novaConta.confirmarSenha"
                        autocomplete="nope"
                      />
                      <span
                        class="invalid-feedback"
                        v-if="errors.length > 0"
                      >A confirmação da senha deve ser igual</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>

              <button
                class="btn btn-primary btn-block btn-lg"
                type="submit"
                :disabled="loadingCriarConta"
              >
                <span v-if="loadingCriarConta">Criando sua conta...</span>
                <span v-else>Criar conta agora! Grátis!</span>
              </button>
              <!-- <div class="text-center my-2" v-if="novaConta.tipoConta == config.TIPO_CONTA_PESSOA_FISICA">
                <small>ou</small>
              </div>-->
              <!-- <button
                class="btn btn-info btn-block btn-lg"
                :disabled="loadingCriarConta"
                v-if="novaConta.tipoConta == config.TIPO_CONTA_PESSOA_FISICA"
              >Criar conta com Facebook</button>-->
              <div class="text-center my-2">
                <small>
                  Ao clicar no botão acima, eu aceito os
                  <a
                    :href="config.URL_TERMOS_USO"
                    target="_blank"
                  >Termo de Uso</a>.
                </small>
              </div>
            </form>
          </ValidationObserver>

          <div class="text-center">
            <hr />
            <strong>Já tem uma conta?</strong>
            <!-- <button class="btn btn-link p-1" v-b-modal:modal-login>Entre com o seu login</button> -->
            <router-link class="btn btn-link p-1" :to="getRotaLogin()">Entre com o seu login</router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- <ModalLogin @login-success="onLoginSuccess" :esconderNovaConta="true"></ModalLogin> -->
  </div>
</template>

<script>
import axios from "axios";
//import facebookLogin from "facebook-login-vuejs";
import Swal from "sweetalert2";

import auth from "../core/auth";
import config from "../config";
import captureError from "../helpers/captureError";
// import ModalLogin from "../components/Login/ModalLogin";

export default {
  components: {
    // ModalLogin
  },
  data() {
    return {
      config,
      novaConta: {
        nome: undefined,
        email: undefined,
        tipoConta: config.TIPO_CONTA_PESSOA_FISICA,
      },
      loadingCriarConta: false,
    };
  },
  created() {
    var userInfo = auth.getUserInfo();
    var clienteLogado = userInfo?.token;

    //Se possui cliente logado, redireciona para a home
    if (clienteLogado) {
      this.$router.replace("/");
    }
  },
  methods: {
    async onClickCriarConta() {
      try {
        this.loadingCriarConta = true;
        var response = await axios.post(
          `${config.API_URL}/auth/criarConta`,
          this.novaConta
        );
        auth.setUserInfo(response.data);

        //Redireciona para a home
        //this.$router.replace("/");
        this.loginRedirect();
      } catch (e) {
        if (e.response && e.response.data && e.response.data.jaExiste) {
          this.contaJaExiste();
        } else {
          captureError(e);
          Swal.fire({
            title: "Não foi possível criar a conta",
            text: "Tente novamente mais tarde ou contate o suporte.",
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      }
      this.loadingCriarConta = false;
    },
    contaJaExiste() {
      var msg = "Já existe um conta cadastrada com este e-mail.";
      if (this.novaConta.tipoConta == config.TIPO_CONTA_PESSOA_JURIDICA) {
        msg = "Já existe um conta cadastrada com este e-mail ou CNPJ.";
      }

      Swal.fire({
        title: "Oops...",
        html:
          msg +
          "<br/><br/> Caso a conta seja sua, deseja receber por e-mail as instruções para recuperar a senha?",
        icon: "warning",
        showCancelButton: true,
        //confirmButtonColor: "#d33",
        confirmButtonText: "Sim, receber instruções",
        cancelButtonText: "Não",
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: async () => {
          Swal.showLoading();
          await this.recuperarSenha();
        },
      });
    },
    // onLoginSuccess() {
    //   this.$router.replace("/");
    // },
    loginRedirect() {
      var returnUrl = this.$route.query.returnUrl || "/";
      this.$router.replace(decodeURIComponent(returnUrl));
    },
    getRotaLogin() {
      var returnUrl = this.$route.query.returnUrl || "/";
      return "/login?returnUrl=" + returnUrl;
    },
    onChangeTipoConta() {
      this.novaConta.cnpj = undefined;
      this.novaConta.razaoSocial = undefined;
      this.novaConta.nome = undefined;
    },
    async recuperarSenha() {
      var email = this.novaConta.email;
      
      if (!email) {
        return;
      }

      try {
        await axios.post(
          `${config.API_URL}/auth/esqueciSenha?email=${email}`,
          {}
        );

        await Swal.fire({
          icon: "success",
          title: "E-mail de instruções enviado com sucesso.",
        });

        this.$router.replace("/");
      } catch (e) {
        this.loading = false;

        // if (e.response && e.response.data && e.response.data.invalido) {
        //   Swal.fire({
        //     icon: "warning",
        //     title: "Atenção",
        //     text:
        //       "O e-mail informado não foi encontrado em nossos cadastros. Verifique os dados e tente novamente.",
        //   });
        //   return;
        // }

        captureError(e);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            "Não foi possível enviar o e-mail. Tente novamente mais tarde ou contate o suporte.",
        });
      }
    },
  },
};
</script>

<style scoped>
.form-group label {
  font-weight: bold;
  font-size: 0.9rem;
}
</style>